import axios from "axios";

const authServices = axios.create({
  baseURL: `https://api.aranathgroup.com`,
  headers: {
    Accept: "application/json",
  },
});

export const authInstanceMultipart = axios.create({
  baseURL: `https://api.aranathgroup.com`,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const sendData = async (data) => {
  const response = await authServices.post(
    `/api/inquiry/addBusinessPartner`,
    data
  );
  return response?.data;
};
export const addChannelPartner = async (data) => {
  const response = await authServices.post(
    `/api/inquiry/addChannelPartner`,
    data
  );
  return response?.data;
};
export const addRedevelopmentInquiry = async (data) => {
  const response = await authServices.post(
    `/api/inquiry/addRedevelopmentInquiry`,
    data
  );
  return response?.data;
};

export const listOfCity = async (data) => {
  const response = await authServices.post(`/api/listOfCity`, data);
  return response?.data;
};

export const fileUploads = async (data) => {
  const response = await authInstanceMultipart.post(`/api/fileUploads`, data);
  return response?.data;
};
export const addContactUs = async (data) => {
  const response = await authServices.post(`/api/inquiry/addContactUs`, data);
  return response?.data;
};
